import React from "react";
import { Mail, Phone } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { CONTACT_INFO, LOGO } from "../data/content";

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer className="media-dark relative bg-[#030305] border-t border-white/10 py-14" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-8">
          <div>
            <div className="flex items-center mb-3">
              <span className="inline-flex items-center rounded-xl bg-white px-4 py-2.5">
                <img src={LOGO} alt="MACAS BV" className="h-16 w-auto" />
              </span>
            </div>
            <p className="text-sm text-zinc-500 max-w-xs">{t("footer_tagline")}</p>
          </div>
          <div className="font-mono text-sm text-zinc-500 space-y-1">
            <div>{CONTACT_INFO.address}</div>
            <div className="flex flex-wrap items-center gap-2">
              <a
                href={`mailto:${CONTACT_INFO.email}`}
                data-testid="footer-email-link"
                className="text-cyan inline-flex items-center gap-1.5 hover:underline underline-offset-4 transition-colors"
              >
                <Mail size={14} />
                {CONTACT_INFO.email}
              </a>
              <span className="text-zinc-600">·</span>
              <a
                href={`tel:${CONTACT_INFO.phone.replace(/\s/g, "")}`}
                data-testid="footer-phone-link"
                className="text-cyan inline-flex items-center gap-1.5 hover:underline underline-offset-4 transition-colors"
              >
                <Phone size={14} />
                {CONTACT_INFO.phone}
              </a>
            </div>
            <div>{CONTACT_INFO.site}</div>
            <div className="text-zinc-600" data-testid="footer-vat">{CONTACT_INFO.vat}</div>
          </div>
        </div>
        <div className="mt-10 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 text-xs font-mono text-zinc-600">
          <span>© {new Date().getFullYear()} {CONTACT_INFO.company}. {t("footer_rights")}</span>
          <span>{t("footer_offices")}</span>
        </div>
      </div>
    </footer>
  );
};
